import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createChatRoom } from '~/api';
import useToast from '~/store/useToast';
import chatRoomKey from './chatRoomKey';

const useCreateChatRoomMutation = () => {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  return useMutation({
    mutationFn: createChatRoom,
    onError: (error) => {
      console.error(error);
      showToast('error', 'cannot create new chat');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: chatRoomKey.getChatList(),
        refetchType: 'all',
      });
    },
  });
};

export default useCreateChatRoomMutation;
